import React, {useEffect} from 'react'
import Section from '../Section'
import GrayLine from '../../../images/goDigital/Patient/Gray-Line-Patient.svg'
import BlueLine from '../../../images/goDigital/Patient/Blue-Line-Patient.svg'
import useWindowSize from '../../../hooks/useWindowSize'
import SingleVisitSlider from '../../../components/landingPage/MainBanner/Slides/Professional/SingleVisitSlider'
import Button from '../../../components/landingPage/Button'
import { useHistory } from 'react-router-dom'
import useApp from '../../../store/app/appContext'

const GRAY_TEXT= {
  transform:"translateX(7rem)"
}
const BLUE_TEXT= {
  transform:"translateX(-7rem)"
}

const LINE_STYLE = {
  width: "38px",
  height: "2px",
  borderTop: "2px solid #3A3A3A",
  transform: "translate(-16px, 2px)"
}
 
const ARROW_STYLE = {
  borderLeft: "2px solid #3A3A3A",
  borderTop: "2px solid #3A3A3A",
  transform: "rotate(-45deg) translate(0px, -4px)"
}

const ARROW_POSITION = {
  transform: "translate(-46px, 10px)"
}

const BLUE_LINE_STYLE ={
  width: "60px",
  height: "2px",
  borderTop: "2px solid #006BB7",
  transform: "translate(32px, 5px)"
}

const BLUE_ARROW_STYLE = {
  borderRight: "2px solid #006BB7",
  borderBottom: "2px solid #006BB7",
  transform: "rotate(-45deg) translate(12px, 12px)"
}

const BLUE_ARROW_POSITION = {
  transform: "translate(174px, 6px)"
}



function GoDigital() {

  const history = useHistory();
  const size=useWindowSize();

  const { logout, appState: { isAuthenticated, user } } = useApp();

  const scheduleScan = () => {
    if (isAuthenticated) {
      history.push('/scanandgo')
    } else {
      history.push('/login?scanandgo=true')
    }
  }
  
  var lineStyle = {
    borderLeft:"3px dashed black",
    minHeight:"40px",
  }

  return (
    <Section className="mx-auto text-center py-8 md:py-12" id="GoDigitalPat" title="Choosing Digital Dentistry with XiViX" subtitle="The future of dentistry is here, and going fully digital is the only way forward." subtitle2="Improve patient health and wellness with our novel workflow." subtitle2Style={{fontWeight:"600"}}>
      <div className="flex flex-col h-full">
        <div className="flex justify-center mb-8">
          <div className="bg-gray-600 text-white font-semibold text-xs sm:text-lg md:text-xl py-0 sm:py-5 w-1/2 sm:w-80 flex flex-col justify-center">
              <h1>Traditional Workflow</h1>
              <p className="font-light text-gray-300 text-xs md:text-sm">(Long, complex, expensive)</p>
            </div>
          <p className="p-5 text-lpGray text-lg flex flex-col justify-center">VS</p>
          <div className="bg-primary text-white font-semibold text-xs sm:text-lg md:text-xl py-0 sm:py-5 w-1/2 sm:w-80 flex flex-col justify-center">
              <h1>XiViX Workflow</h1>
              <p className="font-light text-gray-300 text-xs md:text-sm">(Shorter, easier, affordable)</p>
            </div>
        </div>
        <div className="flex justify-center w-full max-w-7xl mx-auto gap-0 md:gap-20" style={{height:size.width<size.tailwind.lg? "400px" : "605px", transform: size.width<size.tailwind.xl? "translate(-16px, 0px)" : ""}}>
          <div className="relative flex justify-center" style={{height:size.width<size.tailwind.lg? "400px" : "605px"}}>
            <div className="absolute inset-y-0 -left-72 flex flex-col w-60 justify-between pr-4 lg:pr-0" style={GRAY_TEXT}>
              <div className="mt-4">
                <div className="text-right text-lpGray mb-3" style={{transform: `${size.width<size.tailwind.xl? "translate(0px, 0px)" : "translate(0px, 0px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-xs lg:text-sm">First consultation & Impressions</p>
                </div>
                <div className="text-right text-lpGray" style={{transform: `${size.width<size.tailwind.xl? "translate(-20px, 58px)" : "translate(-30px, 58px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-xs lg:text-sm">Treatment Plan Discussion</p>
                </div>
              </div>
              <div className="mr-8">
                <div className="text-right text-lpGray mb-5 lg:mb-10 pr-4" style={{transform: `${size.width<size.tailwind.xl? "translate(10px, 28px)" : "translate(0px, 28px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-xs lg:text-sm">Temporary prosthesis</p>
                </div>
                <div className="text-right text-lpGray pr-2 lg:pb-2" style={{transform: `${size.width<size.tailwind.xl? "translate(13px, 80px)" : "translate(0px, 78px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-xs lg:text-sm">Try-in & Validation</p>
                </div>
              </div>
              <div className="mb-10">
                <div className="text-right text-lpGray mb-16 mr-2 lg:mr-0" style={{transform: `${size.width<size.tailwind.xl? "translate(7px, 78px)" : "translate(0px, 78px)"}`}}>
                  <h1 className={`text-lg font-semibold hidden lg:block`}>Dentist cabinet</h1>
                  <p className="text-xs lg:text-sm">Placement</p>
                </div>
              </div>
            </div>
            <img alt='gray-line' className="object-contain md:mr-0" src={GrayLine} style={{transform: `${size.width<size.tailwind.xl? "translate(10px, 0px)" : ""}`}}/>
          </div>
          <div className={`flex text-left ${size.width<size.tailwind.lg?"hidden" : ""}`}>
            <div className="flex flex-col justify-end mb-16 -mr-14" style={{transform:"translate(-65px, 0px)", width:"90px"}}>
              <div className="mb-20 relative" style={{transform: "translate(-16px, -55px)"}}>
                <div className="absolute flex" style={ARROW_POSITION}>
                  <div className="w-3 h-3" style={ARROW_STYLE}></div>
                  <div style={LINE_STYLE}></div> 
                </div>
                <h1>Lab work</h1>
                <p className="text-sm text-lpGray">(1-2 weeks)</p>
              </div>
              <div className="mb-2 relative" style={{transform: "translate(0px, -40px)"}}>
                <div className="absolute flex" style={ARROW_POSITION}>
                  <div className="w-3 h-3" style={ARROW_STYLE}></div>
                  <div style={LINE_STYLE}></div> 
                </div>
                <h1>Lab work</h1>
                <p className="text-sm text-lpGray">(1-2 weeks)</p>
              </div>
            </div>
            <div className="flex flex-col justify-around -ml-14" style={{transform: "translate(130px, 0px)", width:"210px"}}>
              <div className="pt-28">
                <div className="absolute flex" style={BLUE_ARROW_POSITION}>
                  <div style={BLUE_LINE_STYLE}></div> 
                  <div className="w-3 h-3" style={BLUE_ARROW_STYLE}></div>
                </div>
                <h1 className="text-primary">CIPP & Lab Works : 2-3 weeks</h1>
                <p className="text-sm text-lpGray">Digital diagnosis & Treatment plan Computer Aided Design & Milling (CAD-CAM)</p>
              </div>
            </div>
          </div>
          <div className="relative flex justify-center" style={{height:size.width<size.tailwind.lg? "400px" : "605px"}}>
            <img alt='blue-line' className="object-contain" style={{transform: `${size.width<size.tailwind.xl? "translate(26px, -3px)" : "translate(0px, -3px)"}`}} src={BlueLine}/>
            <div className="absolute inset-y-0 pl-5 lg:pl-0 -right-72 lg:-right-72 flex flex-col justify-between pt-12 pb-1 w-60" style={BLUE_TEXT}>
              <div className="text-left text-primary pl-2" style={{transform: `${size.width<size.tailwind.xl? "translate(24px, -30px)" : "translate(0px, -24px)"}`}}>
                <h1 className={`text-lg font-semibold hidden lg:block`}>XiViX CoE</h1>
                <p className="text-xs lg:text-sm">Scan & Go Consultation</p>
              </div>
              <div className="text-left text-primary pb-7 pl-14 md:pl-20" style={{transform: `${size.width<size.tailwind.xl? "translate(-24px, -18px)" : "translate(0px, -2px)"}`}}>
                <div className="flex content-center gap-8">
                      <div className={`flex-col justify-center hidden xl:flex`}>OR</div>
                      <div className="flex flex-col text-center lg:ml-4 xl:ml-0" style={{transform: "translate(24px, 0px)"}}>
                          <h1 className="font-semibold min-w-60 text-sm sm:text-xl text-lpGray">Choose Single Visit Dentistry by XiViX</h1>
                          <p className="text-xs sm:text-md">Prep, Scan, Place</p>
                          <div style={lineStyle} className="mx-auto w-2 z-0 flex flex-col justify-around items-start"/>
                          <Button text="Placement" className="mb-2 text-sm sm:text-md"/>
                          <p className="text-xs sm:text-md">*If recommended  by your XiViX dentist</p>
                      </div>
                </div>
              </div>
              <div className="text-left text-primary pl-2" style={{transform: `${size.width<size.tailwind.xl? "translate(24px, -22px)" : "translate(0px, -18px)"}`}}>
                <h1 className={`text-lg font-semibold hidden lg:block`}>XiViX CoE</h1>
                <p className="text-xs lg:text-sm">Placement</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center mt-8">
            <p className="my-4 text-sm lg:text-md">(Length of an average Prosthodontic Treatment Plan, excluding pre-prosthetic procedures)</p>
            <Button text="BOOK A SCAN & GO CONSULTATION" className="w-80 mx-auto" onClick={()=> scheduleScan()}/>
        </div>
      </div>
    </Section>


  )
}

export default GoDigital
